import AbstractListView from '@UI/Store/AbstractListView';
import type FacilityWorkflowRunView from '@UI/Store/WorkflowRuns/Views/FacilityWorkflowRunView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The list is filtered and paginated server-side: `queryKey` is the question that produced this page,
 * compared by `stopOn` against the question the screen currently asks.
 */
class FacilityWorkflowRunsListView extends AbstractListView<FacilityWorkflowRunView> {
	readonly facilityId: number;
	readonly queryKey: string;
	readonly totalRecords: number;

	constructor(
		list: readonly FacilityWorkflowRunView[],
		facilityId: number,
		queryKey: string,
		totalRecords: number,
	) {
		super(list, 'FacilityWorkflowRunsListView');

		this.facilityId = facilityId;
		this.queryKey = queryKey;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}

	/** Replaces the row in place; a row the list does not hold is never added. */
	updateWorkflowRun(workflowRun: FacilityWorkflowRunView): FacilityWorkflowRunsListView {
		if (this.findById(workflowRun.id) === null) {
			return this;
		}

		return new FacilityWorkflowRunsListView(
			this.list.map((entry) => (entry.id === workflowRun.id ? workflowRun : entry)),
			this.facilityId,
			this.queryKey,
			this.totalRecords,
		);
	}
}

export default FacilityWorkflowRunsListView;
